export default "__VITE_ASSET__C2h7CLb6__"